import {RecalboxRGBDualOrderPage} from "../../features/rgbdual/order/RecalboxRGBDualOrder"

export default RecalboxRGBDualOrderPage.Page
